module.exports = "<app-header></app-header>\n<div style=\"margin: 100px 0 40px 0\"><router-outlet></router-outlet></div>\n"